/**
 * reducer入口文件
 */
import { combineReducers } from "redux";
import todos from "./todos";
import localState from "./localState"

export default combineReducers({ todos,localState });



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js